import { useState } from 'react'
import { mutate } from 'swr'
import { Update_School_Class } from '@graphql/mutations'
import { Books_Listing, Single_SchoolClass } from '@graphql/queries'
import { useApi } from '@hooks/useApi'

const useUpdateSchoolClass = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      { input: data },
      Update_School_Class,
      successMessage ? successMessage : 'Elev tillagd.',
      errorMessage
        ? errorMessage
        : 'Nåt gick fel när eleven skulle läggas till.',
      async () => {
        await mutate([Single_SchoolClass, data.id])
        await mutate(Books_Listing)
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateSchoolClass }
